import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import Fetcher from '../../common/util/Fetcher';
import { csvFormat } from '../components/resources/NewQuizAndItemAnalysis/exportFormats';
import { ITEM_ANALYSES } from '@instructure/quiz-common';
import { featureOn } from '../../common/util/featureCheck';
var getFetcher = function getFetcher(format) {
  var mimeType = formatsToMimeTypes.get(format);
  if (!mimeType) {
    throw new Error("Unknown export format ".concat(format, "!"));
  }
  return new Fetcher({
    headers: {
      Accept: mimeType
    },
    injectMissingUserToken: true,
    asyncResponseHandler: function asyncResponseHandler(response) {
      return response;
    }
  });
};
var formatsToMimeTypes = new Map().set(csvFormat, 'text/csv');
export var getAnalysesExport = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(quizId, format) {
    var filter,
      analysisType,
      fetcher,
      isMultiAttemptEnabled,
      isStudent_analysis,
      selectedFilter,
      url,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          filter = _args.length > 2 && _args[2] !== undefined ? _args[2] : 'last_attempt';
          analysisType = _args.length > 3 && _args[3] !== undefined ? _args[3] : ITEM_ANALYSES;
          fetcher = getFetcher(format);
          isMultiAttemptEnabled = featureOn('student_analysis_multiple_attempts');
          isStudent_analysis = analysisType === 'student_analysis';
          selectedFilter = isMultiAttemptEnabled && isStudent_analysis ? 'all_attempts' : filter;
          url = "/api/quizzes/".concat(quizId, "/analyses/export?filter=").concat(selectedFilter, "&analysis_type=").concat(analysisType);
          _context.next = 9;
          return fetcher.get(url);
        case 9:
          return _context.abrupt("return", _context.sent);
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getAnalysesExport(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();